<script lang="ts">
import { defineComponent } from "vue";
import { injectPool } from "@/shared/utils/injection";
import KlereoBanner from "@/shared/components/KlereoBanner.vue";
import AlertDetails from "@/features/alerts/AlertDetails.vue";

export default defineComponent({
  components: { AlertDetails, KlereoBanner },
  ...injectPool,
});
</script>

<template>
  <div class="alerts-view">
    <klereo-banner
      left-icon="arrow-left"
      :left-link="`/pool/${$route.params.poolId}`"
      :title="pool.poolNickname + ' / ' + $t('Alert')"
    />

    <div class="lg:max-w-3xl lg:m-auto pt-5">
      <div
        class="card p-3 mb-2"
        v-for="alert in pool.alerts"
        :key="alert.index"
      >
        <AlertDetails :alert="alert" :pool="pool" />
      </div>
    </div>
  </div>
</template>
